import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import PostBacksContext from '@/modules/pb/contexts/PostBacksContext';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import Table from '@/modules/common/components/Table';
import TableContainer from '@/modules/common/components/TableContainer';
import AutocompleteMultilineField from '@/modules/common/components/AutocompleteMultilineField';

const Component = (props) => {
    const pbContext = useContext(PostBacksContext);

    const getClassName = (pb) => {
        let className = 'context-menu';
        if (props.selectedPostBack && props.selectedPostBack.id === pb.id) {
            className += ' selected';
        }
        return className;
    };

    return (
        <TableContainer responsive={true}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell className="offer">Оффер</TableCell>
                        <TableCell className="type">Тип заявки</TableCell>
                        <TableCell className="status">Статус</TableCell>
                        <TableCell className="url">URL</TableCell>
                    </TableRow>
                    <TableRow className="table-row-filter">
                        <TableCell className="offer">
                            <AutocompleteMultilineField options={pbContext.data.offers}
                                                        value={pbContext.valuesFilter.offers}
                                                        setValue={(value) => pbContext.setValuesFilter({...pbContext.valuesFilter, offers: value})}
                            />
                        </TableCell>
                        <TableCell className="type">
                            <AutocompleteMultilineField options={pbContext.data.types}
                                                        value={pbContext.valuesFilter.types}
                                                        setValue={(value) => pbContext.setValuesFilter({...pbContext.valuesFilter, types: value})}
                            />
                        </TableCell>
                        <TableCell className="status">
                            <AutocompleteMultilineField options={pbContext.data.statuses}
                                                        value={pbContext.valuesFilter.statuses}
                                                        setValue={(value) => pbContext.setValuesFilter({...pbContext.valuesFilter, statuses: value})}
                            />
                        </TableCell>
                        <TableCell className="url"/>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.postbacks.map((pb) => (
                        <TableRow key={pb.id} className={getClassName(pb)} onContextMenu={props.onContextMenu(pb)}>
                            <TableCell className="offer">
                                <Link to={`/offers/${pb.offer.offer_name}/`}>
                                    {pb.offer.offer_name}
                                </Link>
                            </TableCell>
                            <TableCell className="type">
                                {(pb.type)
                                    ? <>{pb.type.name}</>
                                    : null
                                }
                            </TableCell>
                            <TableCell className="status">
                                {pb.status.status}
                            </TableCell>
                            <TableCell className="url">{pb.url}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

Component.propTypes = {
    selectedPostBack: PropTypes.object,
    postbacks: PropTypes.array.isRequired,
    onContextMenu: PropTypes.func.isRequired,
};

export default Component;
